import React from 'react';

const IE9 = () => (
  <div >
    "Your browser is not supported. Please update your browser or use a different one."
  </div >
);

export default IE9;



// WEBPACK FOOTER //
// ./src/containers/AppContainer/IE9.js